module.exports = __webpack_public_path__ + "static/media/iap-backing.899c44d0.png";